import { OrdinaryObject } from "src/modules/utils/shared/ordinary-object.model";

export class GeneralObjectKey {
    //netgen start
    type: string;
    key: OrdinaryObject;
    //netgen end

    constructor(type: string, key: OrdinaryObject) {
        this.type = type;
        this.key = key;
    }

}
